import { useMemo } from 'react';

import uniq from 'lodash/uniq';
import { FilterSelect, useSearchContext } from '@cast/shared-search-ui';

import { Cluster } from '@cast/types';
import { Box } from '@cast/design-system';

type RegionFilterProps = {
  fullWidth?: boolean;
};

export const RegionFilter = ({ fullWidth }: RegionFilterProps) => {
  const searchCtx = useSearchContext<Cluster>();

  const options = useMemo(
    () =>
      uniq(
        (searchCtx?.data
          ?.map((cluster) => cluster.region.name)
          .filter((name) => !!name) as string[]) || []
      ),
    [searchCtx?.data]
  );

  return (
    <Box sx={fullWidth ? { width: '100%' } : undefined}>
      <FilterSelect
        criterion="region"
        options={options}
        SelectProps={{ inputText: 'Region', size: 'md' }}
        multiple
        sx={{ width: '100%' }}
        testId="clusters-region-filter"
      />
    </Box>
  );
};
